import { CancelTicket } from "../../molecules/cancelTicket/CancelTicket";

interface ConditionalWrapperProps {
  ticketUpdateData: any;
  children: any;
}

export const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({
  ticketUpdateData,
  children,
}) => {
  const showCancelTicket =
    ticketUpdateData?.currentMedicalStatusResponse?.isAmbulanceRequired ===
      "No" &&
    ticketUpdateData?.currentMedicalStatusResponse
      ?.isDoctorConsultationRequired === "No";

  return (
    <>
      {children}
      {showCancelTicket && <CancelTicket />}
    </>
  );

};
